import { render, staticRenderFns } from "./MultiSql.vue?vue&type=template&id=2b2b8f3d&"
import script from "./MultiSql.vue?vue&type=script&lang=js&"
export * from "./MultiSql.vue?vue&type=script&lang=js&"
import style0 from "./MultiSql.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports